import React, { useMemo } from 'react';
import { ToggleButton, Flex } from '@leverege/ui-elements';
import { LabelText, ValueText } from '@leverege/ui-attributes';
import isEqual from 'fast-deep-equal';
import I18N from '@leverege/i18n';
import Model from "../model/BucketAggTextViewModel.js";
import { AggFilterCreatorFactory } from "../../actions/clickActions/Factory.js";
import { buildVariant } from "../../util/index.js";
import { cleanFilter } from "../../actions/clickActions/Util.js";
import S from './BucketAggTextView.css';
import { AggClickActionFactory } from "../Factory.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.aggregations.BucketAggTextView');
export default function BucketAggTextItem({
  bucket,
  bucketName,
  context,
  delegate,
  filter,
  objectType,
  onClickBucket,
  queryModel,
  value,
  variant,
  vLStyle,
  vTStyle
}) {
  const clickDisabled = useMemo(() => {
    const action = AggClickActionFactory.get(queryModel);
    return action.handles ? !action.handles(bucket, {
      ...context,
      queryModel
    }) : false;
  }, [queryModel, context, bucket]);
  const isFiltered = useMemo(() => {
    const possibleFilter = cleanFilter(AggFilterCreatorFactory.create(queryModel.type, bucket, {
      queryModel,
      objectType,
      delegate,
      context: context?.clientProps
    })?.metadata?.filter?.rootCondition);
    const currentFilter = cleanFilter(filter?.rootCondition);
    if (possibleFilter && currentFilter) {
      return isEqual(possibleFilter, currentFilter);
    }
    return false;
  }, [context, delegate, objectType, queryModel, bucket, filter]);
  const shouldLocalize = Model.getValueTextLocalize(value);
  return /*#__PURE__*/_jsx(ToggleButton, {
    disabled: clickDisabled,
    title: clickDisabled ? null : isFiltered ? t('removeFilter', {
      bucketName
    }) : t('addFilter', {
      bucketName
    }),
    onChange: onClickBucket,
    eventData: bucket,
    value: isFiltered,
    variant: buildVariant(variant),
    children: /*#__PURE__*/_jsxs(Flex, {
      className: S.bucket,
      variant: buildVariant(variant, 'BucketFlex', 'colLStart'),
      children: [Model.getValueLabelVisible(value) && /*#__PURE__*/_jsx(LabelText, {
        variant: buildVariant(variant, 'Label'),
        style: vLStyle,
        children: bucketName
      }), /*#__PURE__*/_jsx(ValueText, {
        variant: buildVariant(variant, 'Value'),
        style: vTStyle,
        children: shouldLocalize && typeof bucket.count === 'number' ? Number(bucket.count).toLocaleString() : bucket.count
      })]
    })
  });
}